export type EC2InstanceOption = {
  name: string;
  id?: string;
  availabilityZone?: string;
  region?: string;
  connectionId?: string;
  subnetId?: string;
  vpcId?: string;
  [key: string]: unknown;
};

export type ECInstanceStepValue = {
  availabilityZone?: string;
  awsAccount: string;
  awsRegion: string;
  region: string;
  tempDestination?: string;
  instanceType: string;
  subnet: string;
  subnetId: string;
  securityGroup: string;
  ami?: string;
  connectionId?: string;
  valid: boolean;
};

export const EC2FullValue: ECInstanceStepValue = {
  availabilityZone: '',
  awsAccount: '',
  awsRegion: '',
  region: '',
  tempDestination: '',
  instanceType: '',
  subnet: '',
  subnetId: '',
  securityGroup: '',
  ami: '',
  connectionId: '',
  valid: true
};

export const EC2TargetInstanceStepValue: ECInstanceStepValue = {
  availabilityZone: '',
  awsAccount: '',
  awsRegion: '',
  region: '',
  tempDestination: '',
  instanceType: '',
  subnet: '',
  subnetId: '',
  securityGroup: '',
  connectionId: '',
  valid: true
};

export const EC2TemporaryInstanceStepValue: ECInstanceStepValue = {
  availabilityZone: '',
  awsAccount: '',
  awsRegion: '',
  region: '',
  instanceType: '',
  subnet: '',
  subnetId: '',
  securityGroup: '',
  ami: '',
  connectionId: '',
  valid: true
};
